import { render } from "./ProofUpload.vue?vue&type=template&id=78297f34&scoped=true"
import script from "./ProofUpload.vue?vue&type=script&lang=js"
export * from "./ProofUpload.vue?vue&type=script&lang=js"

import "./ProofUpload.vue?vue&type=style&index=0&id=78297f34&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78297f34"]])

export default __exports__